import { useLocalStorage } from './useStorage.ts';

export type TableId = number | 'template';

export function useCustomTableView(tableId: TableId) {
  return useLocalStorage<string[]>(
    `prefs_CustomTableViews_table_${tableId}`,
    [],
  );
}
